import { render, staticRenderFns } from "./tab.vue?vue&type=template&id=c5f71682&scoped=true"
import script from "./tab.vue?vue&type=script&lang=js"
export * from "./tab.vue?vue&type=script&lang=js"
import style0 from "./tab.vue?vue&type=style&index=0&id=c5f71682&prod&lang=scss"
import style1 from "./tab.vue?vue&type=style&index=1&id=c5f71682&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f71682",
  null
  
)

export default component.exports